module.exports = __webpack_public_path__ + "img/banner3.3c9e871.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner3.png
// module id = 6Ct8
// module chunks = 2